import DivisorLineForm from './DivisorLineForm'

export default DivisorLineForm
